// NPM Imports
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { Button } from "../../../revvComponents";

// Components Import
import CreateTemplatePopup from "../../CreateTemplatePopup";
// import TemplateHeaderSearch from "./TemplateHeaderSearch";
// Internal Imports
import withRbac from "../../../app/withRbac";
import { PERMISSIONS } from "../../../constants";
import TemplateHeaderSearch from "./TemplateHeaderSearch";
import PlanUpgrade from "../../PlanUpgrade";
import { buttonClickEvent } from "../../../gtm/gtmutils";
import GTM_EVENTS from "../../../gtm/gtmevents";

// Destructuring
class TemplateHeader extends Component {
  state = {
    showCreateTemplatePopUp: false,
  };

  _toggleTemplatePopUp = () => {
    if (!this.state.showCreateTemplatePopUp)
      buttonClickEvent(GTM_EVENTS.CREATE_TEMPLATE_CLICK);
    this.setState(prevState => ({
      showCreateTemplatePopUp: !prevState.showCreateTemplatePopUp,
    }));
  };

  render() {
    // CREATE BTN DISPLAY BASED ON RBAC
    const CreateNewTemplateBtn = withRbac(() => (
      <Button
        type="four"
        data-test="listdoctemplates-create-new-template-button"
        className="createdropdown-btn"
        onClick={this._toggleTemplatePopUp}>
        Create template
      </Button>
    ));
    const { type, showSearchPage, toggleSearchPage, togglePreview } =
      this.props;
    return (
      <Fragment>
        <div className="templateheader-container">
          {/* SEARCH BAR SECTION */}
          <div className="templateheader-title-wrapper">
            <div className="templateheader-title">My Templates</div>
            <div className="templateheader-subtitle">
              All templates created in or added to your Revv org are listed here
            </div>
          </div>
          <TemplateHeaderSearch
            key={type}
            type={type}
            showSearchPage={showSearchPage}
            toggleSearchPage={toggleSearchPage}
            togglePreview={togglePreview}
          />
          {/** CREATE TEMPLATE BTN SECTION */}
          <div className="create-container">
            <CreateNewTemplateBtn
              permission={PERMISSIONS.TEMPLATES.UPDATE_TEMPLATES}
            />
          </div>
          <div style={{ marginLeft: 10 }}>
            <PlanUpgrade showOnlyOnFreePlan templateBtn />
          </div>
        </div>

        {/** CREATE TEMPLATE POPUP COMPONENT */}
        {this.state.showCreateTemplatePopUp && (
          <CreateTemplatePopup closePopUp={this._toggleTemplatePopUp} />
        )}
      </Fragment>
    );
  }
}

TemplateHeaderSearch.propTypes = {
  type: PropTypes.string.isRequired,
  toggleSearchPage: PropTypes.func.isRequired,
  togglePreview: PropTypes.func.isRequired,
};

export default TemplateHeader;
